import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Outlet } from "react-router-dom";

const ToolLandingPage = () => {
  return (
    <>
    <div style={{ position: "relative", minHeight: "100vh", background: "#f8f9fa" }}>
{/* <div style={{maxWidth: "1366px", margin: "0 auto",}}> */}
      <Header />

    <Outlet />

  

      {/* <div style={{ marginBottom: "220px" }}></div> */}
      <Footer />
{/* </div> */}
   

       </div>
    </>
  );
};

export default ToolLandingPage;
